import {GetShippingAPIParams2, ShippingItemListType} from "./apiTypes";
import {useEffect, useState} from "react";
import {queries} from "./queries";
import {useDataAll} from "./useDataAll";
import Feature from "ol/Feature";
import {Point} from "ol/geom";

export type TShippingPointProperty = {
  shipping: ShippingItemListType;
  color: string;
  highlighted?: boolean;
};

export function useShippings(params: GetShippingAPIParams2) {
  const [features, setFeatures] = useState<Feature[]>([]);
  
  const shouldFetchShippingData = !!params.designated_sector__code__in?.length && (!!params.shipping_shop__uuid__in?.length || !!params.pickup_batch__uuid__in?.length || !!params.return_order__shop__uuid__in?.length)
  
  const {listData, error, mutate, isLoading} = useDataAll<ShippingItemListType>(shouldFetchShippingData
    ? queries.shipping.list
    : null, params, 1000)
  
  useEffect(() => {
    let features: Feature[] = [];
    if (listData && listData?.length > 0 && shouldFetchShippingData) {
      listData.forEach((shipping, index) => {
        const marker = createPointFromShipping(shipping, index);
        if (marker) features.push(marker);
      });
    }
    setFeatures(features);
  }, [listData, shouldFetchShippingData]);
  
  const createPointFromShipping = (shipping: ShippingItemListType, index: number) => {
    if (!!shipping.address?.lng && !!shipping.address?.lat) {
      return new Feature({
        name: shipping.tracking_number, geometry: new Point([
          Number(shipping.address?.lng), Number(shipping.address?.lat),
        ]), shipping
      })
    }
    return null;
  };
  
  console.log("useShippings", listData);
  return {
    features, isLoading, mutate, isError: error,
  };
}
